import type { EntityListSliceState, EntitySliceState } from '@luna/api';

import type { ProductState } from '../configurations/productConfigurationRegistry';

export const createProductStateSelector = (
    state: EntityListSliceState<any>,
    stateById: EntitySliceState<any>,
): ProductState => {
    const queryByIdMeta = stateById;

    return {
        didProductInvalidate: state.didInvalidate || queryByIdMeta?.didInvalidate || false,
        error: state.error || queryByIdMeta?.error,
        isProductPending: state.isPending || queryByIdMeta?.isPending || false,
    };
};
